import { render, staticRenderFns } from "./FirstLoginForm.vue?vue&type=template&id=6b52a1d8"
import script from "./FirstLoginForm.vue?vue&type=script&lang=ts"
export * from "./FirstLoginForm.vue?vue&type=script&lang=ts"
import style0 from "./FirstLoginForm.vue?vue&type=style&index=0&id=6b52a1d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports